import { BioConfig } from './@types/BioConfig';
import { BorderConfig } from './@types/BorderConfig';
import { ThemeConfig } from './@types/ThemeConfig';

let themeConfig: ThemeConfig;

export const getThemeConfig = (): ThemeConfig => {
  if (themeConfig) return themeConfig;

  themeConfig = {
    themePreviewUrl: process.env.REACT_APP_THEME_PREVIEW_URL,
    theme: process.env.REACT_APP_THEME,
  };

  return themeConfig;
};

let bioConfig: BioConfig;
export const getBioConfig = (): BioConfig => {
  if (bioConfig) return bioConfig;

  bioConfig = {
    githubUrl: process.env.REACT_APP_GITHUB_URL,
    linkedinUrl: process.env.REACT_APP_LINKEDIN_URL,
    aboutUrl: process.env.REACT_APP_ABOUT_URL,
  };

  return bioConfig;
};

let borderConfig: BorderConfig;
export const getBorderConfig = (): BorderConfig => {
  if (borderConfig) return borderConfig;

  borderConfig = {
    showBorder: process.env.REACT_APP_BORDER === 'true',
  };

  return borderConfig;
};
